import { render, staticRenderFns } from "./sealChange.vue?vue&type=template&id=240f1e02&scoped=true"
import script from "./sealChange.vue?vue&type=script&lang=js"
export * from "./sealChange.vue?vue&type=script&lang=js"
import style0 from "./sealChange.vue?vue&type=style&index=0&id=240f1e02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f1e02",
  null
  
)

export default component.exports